module.exports = __webpack_public_path__ + "static/img/dr-image.7d91053.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/dr-image.svg
// module id = Pnfn
// module chunks = 1